var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.594,
    height: 14.224,
    viewBox: "0 0 16.594 14.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "external-link-symbol",
    transform: "translate(0 -36.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0 36.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M12.742,80.2h-.593a.286.286,0,0,0-.3.3v2.963a1.486,1.486,0,0,1-1.482,1.481h-7.7a1.427,1.427,0,0,1-1.046-.435,1.427,1.427,0,0,1-.435-1.046v-7.7A1.426,1.426,0,0,1,1.62,74.71a1.427,1.427,0,0,1,1.046-.435H9.186a.285.285,0,0,0,.3-.3v-.593a.285.285,0,0,0-.3-.3H2.667a2.569,2.569,0,0,0-1.885.782A2.569,2.569,0,0,0,0,75.757v7.7a2.568,2.568,0,0,0,.782,1.884,2.569,2.569,0,0,0,1.885.783h7.7a2.672,2.672,0,0,0,2.667-2.667V80.5a.286.286,0,0,0-.3-.3Z",
    transform: "translate(0 -71.905)",
    fill: "#143340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M205.643,36.723a.57.57,0,0,0-.417-.176h-4.741a.589.589,0,0,0-.417,1.009l1.63,1.63-6.038,6.038a.291.291,0,0,0,0,.426l1.056,1.056a.291.291,0,0,0,.426,0l6.038-6.038,1.63,1.63a.593.593,0,0,0,1.009-.417V37.14A.57.57,0,0,0,205.643,36.723Z",
    transform: "translate(-189.225 -36.547)",
    fill: "#143340"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f9754830e49d086737faf3008bba3efb.svg";
export { ForwardRef as ReactComponent };